import app from "@/common/plugins/vueInstance";
import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Skeleton from "primevue/skeleton";
import Sidebar from "primevue/sidebar";
import Tooltip from "primevue/tooltip";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Message from "primevue/message";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Paginator from "primevue/paginator";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import RadioButton from "primevue/radiobutton";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import InputSwitch from "primevue/inputswitch";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import ProgressSpinner from "primevue/progressspinner";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import FileUpload from "primevue/fileupload";
import Image from "primevue/image";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import locale from "./locale";

app.use(PrimeVue, {
  locale,
});
app.use(ToastService);

app.component("Image", Image);
app.component("Toast", Toast);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("Skeleton", Skeleton);
app.component("Sidebar", Sidebar);
app.directive("tooltip", Tooltip);
app.component("Button", Button);
app.component("Dialog", Dialog);
app.component("Message", Message);
app.component("Paginator", Paginator);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("RadioButton", RadioButton);
app.component("Calendar", Calendar);
app.component("Dropdown", Dropdown);
app.component("Checkbox", Checkbox);
app.component("Textarea", Textarea);
app.component("InputSwitch", InputSwitch);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("ProgressSpinner", ProgressSpinner);
app.component("IconField", IconField);
app.component("InputIcon", InputIcon);
app.component("FileUpload", FileUpload);
